import {
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useForm, useFormState } from "react-final-form";

import CannotViewField from "../fields/CannotViewField";
import { get } from "lodash";
import { useDebounce } from "ra-friendsofbabba";
import usePrivileges from "../usePrivileges";
import { useRef } from "react";
import { useTranslate } from "ra-core";

const CheckboxRow = ({ disabled, item, source }) => {
  const form = useForm();
  const formState = useFormState();
  const translate = useTranslate();
  const { value, notes, validationError } = useMemo(() => {
    const filledItems = get(formState.values, source, []);
    const target = get(filledItems, `[${item.id - 1}]`);
    const index = filledItems.indexOf(target);
    let notes = get(target, "notes", "");
    if (notes === null) {
      notes = "";
    }
    const submitError = get(formState.submitErrors, source);
    const validationError = get(submitError, `${index}.value`);
    const value = get(target, "value", "");

    return { value, notes, validationError };
  }, [formState, source, item]);
  const [check, setCheck] = useState(value);
  const [text, setText] = useState(notes);
  const handleCheckChange = useCallback((e) => setCheck(e.target.value), []);
  const handleTextChange = useCallback((e) => setText(e.target.value), []);
  const debouncedCheck = useDebounce(check, 500);
  const debouncedText = useDebounce(text, 500);
  const didMount = useRef(false);
  useEffect(
    () => {
      if (didMount.current === false) {
        didMount.current = true;
        return;
      }
      const filledItems = get(formState.values, source, []);
      const target = filledItems.find((fi) => fi.eval_item_id === item.id);

      if (target) {
        target.value = debouncedCheck;
        target.notes = debouncedText;
      }

      form.change(source, [...filledItems]);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedCheck, debouncedText]
  );

  return (
    <TableRow key={item.id}>
      <TableCell>
        <Typography variant="body2" color={validationError && "error"}>
          {item.name}
        </Typography>
        <FormGroup error={validationError}>
          <RadioGroup
            color={validationError && "error"}
            aria-label={item.name}
            name={`check_${item.id}`}
            value={check}
            onChange={handleCheckChange}
            row
          >
            <FormControlLabel
              value={"true"}
              disabled={disabled}
              control={<Radio />}
              label={translate("app.label.yes")}
            />
            <FormControlLabel
              value={"false"}
              disabled={disabled}
              control={<Radio />}
              label={translate("app.label.no")}
            />
          </RadioGroup>
          {validationError && (
            <FormHelperText error>{validationError}</FormHelperText>
          )}
        </FormGroup>

        <TextField
          label={translate(
            "resources.technical-report-eval-items.fields.notes"
          )}
          variant="filled"
          onChange={handleTextChange}
          value={text}
          multiline
          disabled={disabled}
          fullWidth
        />
      </TableCell>
    </TableRow>
  );
};

const CheckboxItemInputWrapper = ({ title, evalItems, ...props }) => {
  const items = useMemo(
    () => evalItems.filter((ei) => ei.group === props.bind),
    [evalItems, props.bind]
  );
  const translate = useTranslate();
  if (items.length === 0) {
    return null;
  }
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>{translate(title)}</TableCell>
          <TableCell>&nbsp;</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {items.map((item) => (
          <CheckboxRow key={item.id} item={item} {...props} />
        ))}
      </TableBody>
    </Table>
  );
};

const CheckboxItemInput = ({ tab, ...props }) => {
  // const visible = useTabVisibiliy(tab);
  // if (!visible && tab > 0) {
  //   return null;
  // }
  const { canView } = usePrivileges({ ...props });
  if (!canView) {
    return <CannotViewField {...props} />;
  }
  return <CheckboxItemInputWrapper {...props} />;
};

export default CheckboxItemInput;
